/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }

    const { project } = feature;
    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const BT_NAME="${feature.getSettingValue('DEVICENAME')}"
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'Bluetooth setup
    '================================================================
    bt.name=BT_NAME
    bt.emulation=${feature.getSettingValue('EMULATION')}
    bt.txbuffrq(${feature.getSettingValue('TXBUF')})
    bt.rxbuffrq(${feature.getSettingValue('RXBUF')})
    sys.buffalloc()    
    '-----------------------------------------------------------------`,
    });


    return blocks;
};
